// https://developers.google.com/actions-center/verticals/appointments/redirect/integration-steps/conversion-tracking#sending_conversion_data

const merchantNotChanged = 2; // when the customer completed a transaction through the original Entity (Merchant).

export const postRwgConversionCollect = async ({
  rwgToken,
  merchantChanged = merchantNotChanged, // 通常 STORES 予約においてマーチャント間を遷移する導線はないのでデフォルトとして設定
}: {
  rwgToken: string;
  merchantChanged?: number;
}) => {
  const endpoint = process.env.NEXT_PUBLIC_RWG_CONVERSION_COLLECT_URL;
  const partnerId = process.env.NEXT_PUBLIC_RWG_PARTNER_ID;

  if (!endpoint || !partnerId) {
    return;
  }

  fetch(endpoint, {
    method: 'POST',
    body: JSON.stringify({
      conversion_partner_id: partnerId,
      rwg_token: rwgToken,
      merchant_changed: merchantChanged,
    }),
  });
};
